import React from "react";

const ExperienceHeader = () => (
  <div className="max-w-2xl">
    <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#6D28D9]">
      Healthcare Plans
    </p>
    <h1 className="mt-1.5 text-[24px] sm:text-[28px] lg:text-[30px] font-extrabold text-[#14131A] leading-[1.2] tracking-tight">
      Choose the <span className="text-purple-700">right healthcare plan</span>
    </h1>
    <p className="mt-2 text-sm sm:text-[15px] text-[#434246] leading-relaxed">
      Explore ready-made OPD plan or build a plan around the healthcare
      benefits you need.
    </p>
  </div>
);

export default ExperienceHeader;
